<template>
  <div class="w-full pb-52 lg:py-12 lg:px-12 h-auto">
    <ul class="list-none">
      <NavFirstLevelCategory
        v-for="firstLevelCategory in firstLevelCategories"
        :key="firstLevelCategory.id"
        :category="firstLevelCategory"
        class="mb-3 bg-EXPONDO-white"
      />
    </ul>
  </div>
</template>

<script lang="ts">

import type { Category } from '~~/types/commercetools';

export default defineComponent({
  name: 'NavBody',

  props: {
    firstLevelCategories: {
      type: Array as PropType<Category[]>,
      default: () => {

        return [];
      
      },
    },
  },
});

</script>
